import ModalLayout from "@/ui/modals/ModalLayout.tsx";
import st from "@/styles/Modals.module.scss";
import Images from "@/utils/images.ts";
import Button from "@/ui/Button.tsx";
import {useEffect, useRef, useState} from "react";
import {useTranslation} from "react-i18next";
import eventEmitter from "@/utils/event_emmiter_instance.ts";
import CommonClass from "@/utils/common.ts";
import LazyImage from "@/ui/LazyImage.tsx";

const SignContractErr = () => {
    
    const [open, setOpen] = useState(false)
    const effect_ran = useRef<boolean>(false)
    const {t} = useTranslation()
    
    const openModal = (x:boolean) => {
        setOpen(x)
    }
    
    
    useEffect(() => {
        if(!effect_ran.current) {
            eventEmitter.on(CommonClass.ModalEvents.SignContractErr, openModal)
        }
        
        return () => {
            effect_ran.current = true
            
            if(!effect_ran.current) {
                eventEmitter.off(CommonClass.ModalEvents.SignContractErr, openModal)
            }
        }
    }, []);
    
    return (
        <ModalLayout
            className={st.sign_contract_err}
            // open={true}
            open={open}
            innerClassName={st.sign_contract_err_inner}
            on_close_state={() => {
                setOpen(false)
            }}
        >
            
            <>
                <div className={st.header}>
                    <LazyImage className={st.img} src={Images.common.pin_err} alt="promo_sketch" />
                </div>
                
                <div className={st.content}>
                    <div className={st.text_content}>
                        <strong>
                            {t("something_wrong")}
                        </strong>
                        
                        <p>
                            {t("rejected_demand")}
                        </p>
                    </div>
                    
                    <div className={st.controllers}>
                        <Button outlined>
                            {t('main_page')}
                        </Button>
                        
                        <Button>
                            {t('new_demand')}
                        </Button>
                        
                    </div>
                    
                </div>
                
            </>
        
        </ModalLayout>
    )
}

export default SignContractErr